import { bleskczSlice } from '../helpers';

/**
 * @name articleListMarkupHP
 * @description Vytvoří HTML strukturu článku.
 *
 * @param {string} articleTypeClass
 * @param {string} title
 * @param {string} url
 * @param {string} imageUrl
 * @param {string} date
 * @param {Boolean} isPremium
 * @param {string} author
 * @param {array} categoryNames
 * @param {object} trackingData Data pouze pro měření GA4.
 *  {string} id
 *  {Number} index
 *  {string} list
 *  {string} systemId
 *  {string} source
 *
 * @returns {string}
 */

export function articleListMarkupHP(
    articleTypeClass,
    articlePreviewClass,
    title,
    url,
    imageUrl,
    date,
    isPremium,
    author,
    categoryNames,
    trackingData,
    mainCategoryName,
    mainCategoryUrl,
) {
    const { id, index, list, systemId, source } = trackingData;

    const dataTrackList = {
        item: {
            elementId: `${list}-${id}`,
            category: categoryNames ? [...categoryNames] : null,
            author: author ? [author] : null,
            premium: isPremium,
            position: index,
            list,
            title,
            url,
            id,
            systemId,
            type: 'article',
            source,
        },
    };

    return `
    <li class="${articleTypeClass}">
      <article class="${articlePreviewClass}" data-track-list="${JSON.stringify(
          dataTrackList,
      ).replace(/"/g, '&quot;')}" data-track-element-id="${id}">
        <div class="article-preview__top">
          <a class="article-preview__image-link" href="${url}" title="${title}" data-io-canonical-url="${
              url.split('/')[0]
          }//${url.split('/')[2]}/clanek/${id}">
              <img src="${imageUrl}" alt="${title}" title="${title}" width="300" height="169" class="article-preview__image" loading="lazy">
          </a>
          ${
              mainCategoryUrl
                  ? `<a class="article-preview__sticker" href="${mainCategoryUrl}">${mainCategoryName}</a>`
                  : ''
          }
          </div>
          <a class="article-preview__title" href="${url}" title="${title}" data-io-canonical-url="${
              url.split('/')[0]
          }//${url.split('/')[2]}/clanek/${id}">${bleskczSlice(title, 70)}</a>
      </article>
    </li>
  `;
}
